export const VENDOR_CHANGE_PASSWORD_REQUEST = "VENDOR_CHANGE_PASSWORD_REQUEST";
export const VENDOR_CHANGE_PASSWORD_SUCCESS = "VENDOR_CHANGE_PASSWORD_SUCCESS";
export const CLEAR_VENDOR_CHANGE_PASSWORD = "CLEAR_VENDOR_CHANGE_PASSWORD";
